var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7225 16.3078C20.4615 16.7955 19.9532 17.1 19.4 17.1H5C4.44681 17.1 3.93852 16.7955 3.67749 16.3078C3.41646 15.82 3.44507 15.2282 3.75193 14.7679L4.75232 13.2674L5.34944 8.19186C5.75812 4.71803 8.70222 2.1 12.2 2.1C15.6978 2.1 18.6419 4.71804 19.0506 8.19186L19.6477 13.2674L20.6481 14.7679C20.9549 15.2282 20.9835 15.82 20.7225 16.3078ZM18.2 13.8L17.5608 8.36712C17.241 5.64872 14.9372 3.6 12.2 3.6C9.46285 3.6 7.15898 5.64871 6.83916 8.36712L6.2 13.8L5 15.6H19.4L18.2 13.8Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18.25C10.4142 18.25 10.75 18.5858 10.75 19C10.75 19.6904 11.3096 20.25 12 20.25C12.6904 20.25 13.25 19.6904 13.25 19C13.25 18.5858 13.5858 18.25 14 18.25C14.4142 18.25 14.75 18.5858 14.75 19C14.75 20.5188 13.5188 21.75 12 21.75C10.4812 21.75 9.25 20.5188 9.25 19C9.25 18.5858 9.58579 18.25 10 18.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBell);
export default __webpack_public_path__ + "static/media/icon-bell.0e695da7e0d1e7a0686eb5dc2c4a001c.svg";
export { ForwardRef as ReactComponent };